import React from "react";
import * as PropTypes from "prop-types";
import { makeStyles } from "@material-ui/styles";
import styleConstants from "../../../styleConstants";

const useStyles = makeStyles(theme => ({
  container: {
    height: "120vh",
    display: "flex",
    alignItems: "center"
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(5, 1fr)",
    gridTemplateRows: "repeat(3, 1fr)",
    [theme.breakpoints.down("xs")]: {
      gridTemplateColumns: "repeat(3, 1fr)",
      gridTemplateRows: "repeat(6, 1fr)"
    }
  },
  reference: {
    gridArea: "1 / 1 / 4 / 3",
    lineHeight: 0.75,
    fontSize: "23rem",
    fontWeight: styleConstants.fontWeights.black,
    color: styleConstants.colors.themeBlueLight,
    paddingRight: "2rem",
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.down("xs")]: {
      gridArea: "1 / 1 / 4 / 4"
    }
  },
  title: {
    gridArea: "2 / 1 / 4 / 3",
    lineHeight: 1,
    fontSize: "3rem",
    fontWeight: styleConstants.fontWeights.light,
    paddingRight: "2rem",
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.down("xs")]: {
      gridArea: "2 / 1 / 4 / 4"
    }
  },
  content: {
    gridArea: "1 / 3 / 4 / 6",
    lineHeight: styleConstants.fonts.bodyLineHeight,
    fontSize: "1.125rem",
    fontWeight: styleConstants.fontWeights.book,
    color: styleConstants.colors.primary,
    paddingLeft: "2rem",
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.down("xs")]: {
      gridArea: "4 / 1 / 7 / 4"
    }
  }
}));

const ThemeIntroduction = props => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <div className={classes.grid}>
        <div className={classes.reference}>{props.reference}</div>
        <div className={classes.title}>{props.title}</div>
        <div className={classes.content}>{props.children}</div>
      </div>
    </div>
  );
};

ThemeIntroduction.propTypes = {
  reference: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node)
  ]).isRequired
};

export default ThemeIntroduction;
